import i18n from '~/components/i18n'
import { REARING_PHASE_INDIVIDUAL_TYPE, StepId } from './constants'
import { BarleyFormValues } from './Steps/TwelveStep/BarleyModal'
import { YoungCattleValidationFeedGroup } from '~/api/services/climaCheck'
import { formatNumber } from '~/utils/helpers'

export function getNumberOfFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      sum += Object.values(feeds[key]).length
    }
  })
  return sum
}

export function getNumberOfFilledFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      sum += Object.values(feeds[key]).filter(feed => !!feed['value']).length
    }
  })
  return sum
}

export function findJuicyFeed(feeds) {
  const feedGroupWithJuicyFeed = feeds.find(group => group.juicyFeeds && group.juicyFeeds.length > 0);

  // Return the first juicyFeed found, or null if none exists
  if (feedGroupWithJuicyFeed) {
    return feedGroupWithJuicyFeed.juicyFeeds[0];
  }

  return null;
}

export function totalJuicyFeedsSelected(feedGroups) {
  return feedGroups.reduce((previousJuicyFeedsCount, feedGroup) => {
    previousJuicyFeedsCount += feedGroup.juicyFeeds.length
    return previousJuicyFeedsCount
  }, 0)
}

export function getSumOfFilledFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      const feedsSum = feeds[key].reduce((previosValue, currentValue) => {
        if (currentValue.value && Boolean(currentValue.value)) {
          previosValue = previosValue + parseFloat(currentValue?.value?.toString().replace(',', '.'))
          return previosValue
        }
        return previosValue
      }, 0) || 0
      sum = sum + feedsSum
    }
  })
  return sum
}

export function redistributeDays(feedGroups, calfRearingDays) {
  const targetDays = calfRearingDays;
  let totalRoundedDays = 0;
  const remainders = [];

  feedGroups.forEach(group => {
    const roundedDays = Math.floor(group.days);
    totalRoundedDays += roundedDays;
    remainders.push({ index: feedGroups.indexOf(group), remainder: group.days - roundedDays });
    group.days = roundedDays;
  });

  const daysToDistribute = targetDays - totalRoundedDays;
  
  if (daysToDistribute > 0) {
    remainders.sort((a, b) => b.remainder - a.remainder);
    for (let i = 0; i < daysToDistribute; i++) {
      feedGroups[remainders[i].index].days += 1;
    }
  } else if (daysToDistribute < 0) {
    remainders.sort((a, b) => a.remainder - b.remainder);
    for (let i = 0; i < Math.abs(daysToDistribute); i++) {
      feedGroups[remainders[i].index].days -= 1;
    }
  }
  return feedGroups
}

function phaseFeedingDataParse(feedingPhases) {
  feedingPhases.forEach(feedingPhase => {
    feedingPhase.coarseFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
    feedingPhase.concentratedFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
    feedingPhase.juicyFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
  });
  return feedingPhases
}

export function prepareDataForPayload(data) {
  Object.keys(data).forEach(key => {
    if (typeof data[key] === 'string') {
      data[key] = data[key].replace(',', '.');
    } else if (key === 'feedGroups') {
      data.feedGroups.forEach(feedGroup => {
        if (feedGroup.feedingPhases?.length > 0) {
          feedGroup.feedingPhases = phaseFeedingDataParse(feedGroup.feedingPhases)
        } else {
          feedGroup?.coarseFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
          feedGroup?.concentratedFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
          feedGroup?.juicyFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
        }
      });
    } else if (key === 'rearingPhases') {
      data.rearingPhases.forEach(phase => {
        phase?.coarseFeeds?.forEach(feed => {
          feed.value = feed.value?.toString()?.replace(',', '.');
        });
        phase?.concentratedFeeds?.forEach(feed => {
          feed.value = feed.value?.toString()?.replace(',', '.');
        });
      });
    }
    else if ([
      'cowsManureFermentations',
      'calvesManureFermentations',
      'cowsManureStorageTypes',
      'calvesManureStorageTypes',
      'cowsEnergyConsumptions',
      'calvesEnergyConsumptions'
    ].includes(key)) {
      data[key].forEach(item => {
        if(item?.percent?.toString()?.includes(',')) {
          item.percent = item.percent?.toString()?.replace(',', '.');
        }
      });
    } else if (['calvesConcentratedFeeds', 'calvesCoarseFeeds', 'cowsCoarseFeeds', 'cowsConcentratedFeeds', 'juicyFeeds'].includes(key)) {
      data[key].forEach(item => {
        item.dryMatter = item.dryMatter.replace(',', '.');
        item.energy = item.energy.replace(',', '.');
        item.rawFat = item.rawFat?.replace(',', '.');
        item.rawProtein = item.rawProtein?.replace(',', '.');
        item.rawAsh = item.rawAsh?.replace(',', '.');
        item.rawFiber = item.rawFiber?.replace(',', '.');
      });
    } else if (['calvesHousingTypes', 'cowsHousingTypes'].includes(key)) {
      data[key].forEach(item => {
        if(item?.cattleNumber) {
          item.cattleNumber = item.cattleNumber?.toString()?.replace(',', '.');
        }
      });
    } else if (key === 'landTypeChanges') {
      data[key].forEach(item => {
        item.area = item.area?.toString()?.replace(',', '.');
      })
    }
    else if(key === 'additionalQuestions') {
      data?.additionalQuestions?.landscapeFeatureTypes?.map(feature => {
        feature.value = feature.value?.toString()?.replace(',', '.');
      })
      data?.additionalQuestions?.specialEcologicalAreas?.map(area => {
        area.value = area.value?.toString()?.replace(',', '.');
      })
    }
    else if(key === 'weaningWeeksValues') {
      data[key].forEach(item => {
        item.milkReplacer = item.milkReplacer?.toString()?.replace(',', '.');
        item.wholeMilk = item.wholeMilk?.toString()?.replace(',', '.');
        item.calfConcentratedFeed = item.calfConcentratedFeed?.toString()?.replace(',', '.');
      });
    } else if ((key === 'maizeSilage' || key === 'grassSilage') && data[key]) {
      Object.entries(data[key])?.forEach(([propKey, value]) => {
        if (typeof value === 'string') {
          data[key][propKey] = value.replace(',', '.');
        }
      
        if (Array.isArray(value)) {
          value?.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              Object.entries(item)?.forEach(([itemKey, itemValue]) => {
                if (typeof itemValue === 'string') {
                  data[key][propKey][index][itemKey] = itemValue.replace(',', '.');
                }
              });
            }
          });
        }
      });
    }
  });
  return data
}

export function getTransformFeedGroups(feeds) {
  const feedsTransformed = []
  feeds.map((feedGroup, index) => {
    if (feedGroup['feedingPhases'] && feedGroup['feedingPhases']?.length > 0) {
      feedGroup['feedingPhases'].map(feedPhase => {
        const feedGroupTitle = feedGroup['name']
        const title = i18n.t('{{feedTitle}} / {{phaseTitle}}', { feedTitle: feedGroupTitle, phaseTitle: feedPhase.name })
        feedsTransformed.push({ ...feedPhase, feedGroupIndex: index, name: title, type: feedGroup.type })
      })
    } else {
      feedsTransformed.push({ ...feedGroup, feedGroupIndex: index, type: feedGroup.type })
    }
  })
  return feedsTransformed
}

export function getTransformCalvesFeedGroups(feeds) {
  const feedsTransformed = []
  feeds.map((feedGroup, index) => {
    if(feedGroup.type === 3) {
      if (feedGroup['feedingPhases'] && feedGroup['feedingPhases']?.length > 0) {
        feedGroup['feedingPhases'].map(feedPhase => {
          const feedGroupTitle = feedGroup['name']
          const title = i18n.t('{{feedTitle}} / {{phaseTitle}}', { feedTitle: feedGroupTitle, phaseTitle: feedPhase.name })
          feedsTransformed.push({ ...feedPhase, feedGroupIndex: index, name: title, type: feedGroup.type })
        })
      } else {
        feedsTransformed.push({ ...feedGroup, feedGroupIndex: index, type: feedGroup.type })
      }
    }
  })
  return feedsTransformed
}

export function getTransformCowsFeedGroups(feeds) {
  const feedsTransformed = []
  feeds.map((feedGroup, index) => {
    if(feedGroup.type !== 3) {
      if (feedGroup['feedingPhases'] && feedGroup['feedingPhases']?.length > 0) {
        feedGroup['feedingPhases'].map(feedPhase => {
          const feedGroupTitle = feedGroup['name']
          const title = i18n.t('{{feedTitle}} / {{phaseTitle}}', { feedTitle: feedGroupTitle, phaseTitle: feedPhase.name })
          feedsTransformed.push({ ...feedPhase, feedGroupIndex: index, name: title, type: feedGroup.type, validation: feedGroup?.validation || null })
        })
      } else {
        feedsTransformed.push({ ...feedGroup, feedGroupIndex: index, type: feedGroup.type, validation: feedGroup?.validation || null })
      }
    }
  })
  return feedsTransformed
}

export function getStepHeadMessage(stepId: StepId): string {
  switch(stepId) {
    case StepId.DAIRY_DATA:
      return 'Hohe Milchleistungen können einen positiven Einfluss auf den CO<sub>2</sub>-Fußabdruck haben, da die Emissionen für den Erhaltungsbedarf des Tieres auf eine größere Milchmenge verteilt werden.'
    case StepId.DAIRY_COW_METRICS:
      return `Für den Erhaltungsbedarf der Tiere entstehen Emissionen. Eine gute Tiergesundheit, 
      lange Nutzungsdauern und geringe Abgangszahlen haben einen positiven Einfluss auf den CO<sub>2</sub>-Fußabdruck.`
    case StepId.HEIFER_METRICS:
      return `Bitte machen Sie Angaben für alle Tiere <strong>vom 29. Lebenstag (LT) bis zur Abkalbung</strong>. 
      Die Bestandsergänzung verursacht Treibhausgasemissionen und wird der Milch- bzw. Fleischproduktion angerechnet. 
      Je niedriger das Erstkalbealter und die Verluste, desto niedriger ist der CO<sub>2</sub>-Fußabdruck. `
    case StepId.CALF_REARING:
      return `Die Kälberaufzucht verursacht Treibhausgasemissionen und wird der Milch- bzw. Fleischproduktion angerechnet. 
      Je effizienter die Tränke und die Zunahmen und je niedriger die Verluste, desto niedriger ist der CO<sub>2</sub>-Fußabdruck. `
    case StepId.DAIRY_COW_HUSBANDRY:
      return `Wie viele Ihrer Tiere standen in der jeweiligen Haltungsform? 
      Bitte berücksichtigen Sie auch Trockensteher und Vorbereiter, Abkalbeboxen, Krankenboxen etc. 
      Bitte geben Sie hier die gesamte Anzahl an Tieren an, die während der Stallsaison im Stall standen. Die ggf. auf der Weide verbrachte Zeit rechnet das System automatisch gegen.`
    case StepId.HEIFER_HUSBANDRY:
      return `Wie viele Ihrer Tiere standen in der jeweiligen Haltungsform? 
      Bitte geben Sie hier die gesamte Anzahl an Tieren an, die während der Stallsaison im Stall standen. 
      Die ggf. auf der Weide verbrachte Zeit rechnet das System automatisch gegen.`
    case StepId.DAIRY_COW_MANURE:
      return `Die Treibhausgasemissionen sind je nach Art und Lagerung des Wirtschaftsdüngers unterschiedlich hoch.
      Eine gasdichte Lagerung ist besonders effizient bei der Reduktion des CO<sub>2</sub>-Fußabdruckes. <strong>Bitte machen Sie nur Angaben für die Milchkuhherde(n), die Färsen werden später erfasst.</strong>`
    case StepId.HEIFER_MANURE:
      return 'Die Treibhausgasemissionen sind je nach Art und Lagerung des Wirtschaftsdüngers unterschiedlich hoch. Eine gasdichte Lagerung ist besonders effizient bei der Reduktion des CO<sub>2</sub>-Fußabdruckes.'
    case StepId.DAIRY_COW_ENERGY:
      return 'Je niedriger der Verbrauch von fossilen Energieträgern, desto niedriger sind die Treibhaugasemissionen. <strong>Bitte machen Sie nur Angaben für die Milchkuhherde(n), die Färsen werden später erfasst.</strong>'
    case StepId.HEIFER_ENERGY:
      return '<div>Je niedriger der Verbrauch von fossilen Energieträgern, desto niedriger sind die Treibhaugasemissionen.</div>'
    case StepId.PERFORMANCE_GROUP:
      return '<strong>Achtung</strong>: Bitte geben Sie nicht die Infos zur aktuellen Fütterung, sondern zum berücksichtigten Betrachtungszeitraum an!'
    case StepId.DAIRY_COW_FEED:
    case StepId.HEIFER_FEED:
      return `Bitte geben Sie nicht die Infos zur aktuellen Fütterung, sondern zum berücksichtigten Betrachtungszeitraum an! 
      Die Optimierung der Grundfutterqualität hat einen positiven Einfluss auf den CO<sub>2</sub>-Fußabdruck, denn es ist weniger Kraftfutter nötig, um dieselbe Milchleistung zu erbringen.  
      Kraftfuttererzeugung verursacht in der Regel höhere Emissionen als die Grundfuttererzeugung. `
    case StepId.ADDITIVES_USAGE:
      return 'Diese Datenerfassung wirkt sich vorerst nicht auf Ihre Klimabilanz aus.'
    case StepId.LAND_USE:
      return `Diese Datenerfassung wirkt sich vorerst nicht auf Ihre Klimabilanz aus. Die Auswirkungen der Bewirtschaftung organischer Böden auf den CO<sub>2</sub>-Fußabdruck ist sehr stark, 
      derzeit fehlt aber eine ausreichende Datengrundlage und eine valide Zuordnung der Emissionen zu Produkten für eine eindeutige Ausweisung der Emissionen.`
    case StepId.GHG_RESULT:
      return `Die Produkt CO<sub>2</sub>-Fußabdrücke werden mit der Allokation gemäß der International Dairy Federation (IDF) in CO<sub>2</sub>-Äquivalenten je kg verkaufter Milch (FPCM) bzw. 
      je kg Lebendgewicht Schlachtkuh- und Kälberverkauf bzw. je erzeugte Färse und Jahr ausgewiesen. Die IDF-Werte sind international vergleichbar und anerkannt. 
      Die gesamten THG-Emissionen stellen alle auf dem Betrieb angefallenen Emissionen vor der Zuteilung auf die Produkte dar.`
    case StepId.FORAGE_PRODUCTION:
      return 'Bitte geben Sie hier lediglich die Werte für die Futtermittel ein, die Sie an Ihre Milchkühe und Färsen verfüttert haben. Diese Datenerfassung wirkt sich vorerst nicht auf Ihre Klimabilanz aus.'
    case StepId.FORAGE_FEEDS:
      return 'Wie hoch war der Anteil an Futtermitteln, den Sie selbst angebaut haben? Geben Sie diesen jeweils in % hinter dem jeweiligen Futtermittel an. Diese Datenerfassung wirkt sich vorerst nicht auf Ihre Klimabilanz aus.'
    case StepId.SUMMARY:
      return `In dem folgenden Abschnitt werden Ihnen Fragen speziell für die Uelzena-Gruppe gestellt. Hintergrund ist, 
      dass wir von nun an nur noch eine Umfrage im Jahr durchführen werden. Bitte beachten Sie, dass die Antworten auf die folgenden Fragen nicht in die Kalkulation Ihres 
      CO<sub>2</sub>-Fußabdrucks mit einfließen und ausschließlich Kommunikationszwecken der Gruppe dienen. 
      Wie auch bei den anderen Daten im Klima Check Modul besteht für uns keine Möglichkeit, die Daten zurückzuverfolgen, wodurch Ihre Angaben selbstverständlich anonym sind. Vielen Dank für Ihre Kooperation.`
    default:
      return ''
  }
}

export const heiferFeedingPhases = (firstCalvingAge: number) => [
  {
    name: 'Jungtier 1',
    days: 63,
    fixed: true,
    order: 1,
    period: '0-3',
    phase: 1,
    concentratedFeeds: [],
    coarseFeeds: []
  },
  {
    name: 'Jungtier 2',
    days: 91,
    fixed: false,
    order: 2,
    period: '3-6',
    phase: 2,
    concentratedFeeds: [],
    coarseFeeds: []
  },
  {
    name: 'Jungtier 3',
    days: 182,
    fixed: false,
    order: 3,
    period: '7 - 12',
    phase: 2,
    concentratedFeeds: [],
    coarseFeeds: []
  },
  {
    name: 'Jungtier 4',
    days: 365,
    fixed: false,
    order: 4,
    period: '13-24',
    phase: 2,
    concentratedFeeds: [],
    coarseFeeds: []
  },
  {
    name: 'Jungtier 5',
    days: Math.round((firstCalvingAge * 30.5 - 730.5) * 10) / 10,
    fixed: false,
    order: 5,
    period: '24-EKA',
    phase: 2,
    concentratedFeeds: [],
    coarseFeeds: []
  }
];

export const individualPhases = (firstCalvingAge) => [
  {
    name: '1. Aufzuchtphase',
    days: 63,
    fixed: true,
    order: 1,
    period: '0-3 Monate',
    phase: 1,
    concentratedFeeds: [],
    coarseFeeds: []
  },
  {
    name: '2. Aufzuchtphase',
    days:  Math.round(firstCalvingAge * 30.5 - 63 - 28),
    fixed: true,
    order: 2,
    period: '3-EKA Monate',
    phase: 2,
    concentratedFeeds: [],
    coarseFeeds: []
  }
]

function getCowsFeedKey(key: string) {
  switch(key) {
    case 'coarseFeeds':
      return 'cowsCoarseFeeds';
    case 'concentratedFeeds':
      return 'cowsConcentratedFeeds';
    case 'juicyFeeds':
      return 'juicyFeeds'
    default:
      return 'juicyFeeds'
  }
}

export function getCowTotalDryMatter(feeds, feedBarleyValues) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      const feedsSum = feeds[key].reduce((previosValue, currentValue) => {
        if (currentValue.value && Boolean(currentValue.value)) {
          const feedValues = feedBarleyValues[getCowsFeedKey(key)].find(feed => feed.id === currentValue.id)
          const percentDryMatter = feedValues?.dryMatter ? Number((feedValues?.dryMatter / 100).toFixed(4)) : 1
          previosValue = previosValue + parseFloat(currentValue.value.replace(',', '.')) * percentDryMatter
          return previosValue
        }
        return previosValue
      }, 0) || 0
      sum = sum + feedsSum
    }
  })
  return sum
}

function getCalvesFeedKey(key: string) {
  switch(key) {
    case 'coarseFeeds':
      return 'calvesCoarseFeeds';
    case 'concentratedFeeds':
      return 'calvesConcentratedFeeds';
    default:
      return key
  }
}

export function getCalvesTotalDryMatter(feeds, feedBarleyValues) {
  let sum = 0
  console.log(feeds)
  console.log(feedBarleyValues)
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'concentratedFeeds') {
      const feedsSum = feeds[key].reduce((previosValue, currentValue) => {
        if (currentValue.value && Boolean(currentValue.value)) {
          const feedValues = feedBarleyValues[getCalvesFeedKey(key)]?.find(feed => feed.id === currentValue.id)
          const percentDryMatter = feedValues?.dryMatter ? Number((feedValues?.dryMatter / 100).toFixed(2)) : 1
          previosValue = previosValue + parseFloat(currentValue.value.replace(',', '.')) * percentDryMatter
          console.log('previosValue: ', previosValue)
          return previosValue
        }
        return previosValue
      }, 0) || 0
      sum = sum + feedsSum
    }
  })
  return sum
}

const parseValue = (value: string | number): number => {
  if (value === '' || value === null || value === undefined) return NaN
  return typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value
}

export function validateBarleyFields(name: keyof BarleyFormValues, value: string, barleyData): string | null {
  const transformValue = parseValue(value)

  if (!value || value === '') {
    return 'Pflichtfeld'
  }

  if (isNaN(transformValue)) {
    return null
  }

  switch (name) {
    case 'dryMatter':
      if (transformValue < (barleyData?.dryMatterLimitMinValue || 0)) {
        return `Der TM-Wert muss mindestens ${barleyData?.dryMatterLimitMinValue} g/kg TM betragen.`
      }
      if (transformValue > (barleyData?.dryMatterLimitMaxValue || 999)) {
        return `Der TM-Wert darf maximal ${barleyData?.dryMatterLimitMaxValue} g/kg TM betragen.`
      }
      break
    case 'energy':
      if (transformValue < (barleyData?.energyLimitMinValue || 0)) {
        return `Der Energiewert muss mindestens ${barleyData?.energyLimitMinValue} MJ NEL/kg TM betragen.`
      }
      if (transformValue > (barleyData?.energyLimitMaxValue || 999)) {
        return `Der Energiewert darf maximal ${barleyData?.energyLimitMaxValue} MJ NEL/kg TM betragen.`
      }
      break
    case 'rawAsh':
      if (transformValue < (barleyData?.rawAshLimitMinValue || 0)) {
        return `Der Rohaschewert muss mindestens ${barleyData?.rawAshLimitMinValue} g/kg TM betragen.`
      }
      if (transformValue > (barleyData?.rawAshLimitMaxValue || 999)) {
        return `Der Rohaschewert darf maximal ${barleyData?.rawAshLimitMaxValue} g/kg TM betragen.`
      }
      break
    case 'rawProtein':
      if (transformValue < (barleyData?.rawProteinLimitMinValue || 0)) {
        return `Der Rohproteinwert muss mindestens ${barleyData?.rawProteinLimitMinValue} g/kg TM betragen.`
      }
      if (transformValue > (barleyData?.rawProteinLimitMaxValue || 999)) {
        return `Der Rohproteinwert darf maximal ${barleyData?.rawProteinLimitMaxValue} g/kg TM betragen.`
      }
      break
    case 'rawFat':
      if (transformValue < (barleyData?.rawFatLimitMinValue || 0)) {
        return `Der Rohfettwert muss mindestens ${barleyData?.rawFatLimitMinValue} g/kg TM betragen.`
      }
      if (transformValue > (barleyData?.rawFatLimitMaxValue || 999)) {
        return `Der Rohfettwert darf maximal ${barleyData?.rawFatLimitMaxValue} g/kg TM betragen.`
      }
      break
    case 'rawFiber':
      if (transformValue < (barleyData?.rawFiberLimitMinValue || 0)) {
        return `Der Rohfaserwert muss mindestens ${barleyData?.rawFiberLimitMinValue} g/kg TM betragen.`
      }
      if (transformValue > (barleyData?.rawFiberLimitMaxValue || 999)) {
        return `Der Rohfaserwert darf maximal ${barleyData?.rawFiberLimitMaxValue} g/kg TM betragen.`
      }
      break
  }
  return null
}

export const BROWN_COW_ID = 3
export const BLACK_WHITE_COW_ID = 4
export const JERSEY_COW_ID = 5
export const DRY_PERIOD_TYPE = 1
export const LACTATING_PERIOD_TYPE = 2

function getValidationGroupForMonth(month: number | null, validationGroups: YoungCattleValidationFeedGroup[]) {
  if (month === null) {
    // For "EKA" or open-ended periods, use the last group
    return validationGroups[validationGroups.length - 1]
  }
  return validationGroups.find(group => {
    if (group.monthTo === null) {
      return month >= group.monthFrom
    }
    return month >= group.monthFrom && month <= group.monthTo
  })
}

function parseMonthFromPeriod(periodPart: string): number | null {
  const cleaned = periodPart.trim().replace('Monate', '').trim()
  if (cleaned.toUpperCase() === 'EKA') {
    return null // Represents open-ended period (until first calving)
  }
  const parsed = parseInt(cleaned, 10)
  return isNaN(parsed) ? null : parsed
}

export function validateYoungCattleFeedTotals(
  rearingPhasesType: string,
  rearingPhases: any,
  validationGroups: YoungCattleValidationFeedGroup[],
  feedBarleyValues: any
): any {

  const warnings: { phaseName: string; value: number; min: number; max: number }[] = []
  const errors: { phaseName: string; value: number; min: number; max: number }[] = []

  if (rearingPhasesType !== REARING_PHASE_INDIVIDUAL_TYPE) {
    return { warnings, errors }
  }

  if (!validationGroups || validationGroups.length === 0) {
    return { warnings, errors }
  }

  rearingPhases.forEach(phase => {
    const period = phase.period || ''
    const periodParts = period.split('-')

    if (periodParts.length < 2) return

    const fromMonth = parseMonthFromPeriod(periodParts[0])
    const toMonth = parseMonthFromPeriod(periodParts[1])

    const fromGroup = getValidationGroupForMonth(fromMonth, validationGroups)
    const toGroup = getValidationGroupForMonth(toMonth, validationGroups)

    if (!fromGroup || !toGroup) return

    const limitMinValue = fromGroup.limitMinValue
    const limitMaxValue = toGroup.limitMaxValue
    const warningMinValue = fromGroup.warningMinValue
    const warningMaxValue = toGroup.warningMaxValue

    const feedSum = getCalvesTotalDryMatter(phase, feedBarleyValues)
    const roundedSum = Math.round(feedSum * 100) / 100

    const phaseName = `${phase.name || ''} (${period} Monate)`

    if (roundedSum < limitMinValue || roundedSum > limitMaxValue) {
      errors.push({
        phaseName,
        value: roundedSum,
        min: limitMinValue,
        max: limitMaxValue
      })
    } else if (roundedSum < warningMinValue || roundedSum > warningMaxValue) {
      warnings.push({
        phaseName,
        value: roundedSum,
        min: warningMinValue,
        max: warningMaxValue
      })
    }
  })

  return { warnings, errors }
}

function formatNumberToInt(number) {
  return parseInt(formatNumber(number, 0).replace(',', '.'))
}

function getDaysFromCowsNumber(cowsNumber, calvingPeriod) {
  const calvingDays = formatNumberToInt(calvingPeriod)
  const totalCowsNumber = parseInt(cowsNumber.toString().replace(',', '.'))
  const feedGroupCowsNumber = cowsNumber === '' ? 0 : parseInt(cowsNumber)
  return feedGroupCowsNumber * calvingDays / totalCowsNumber
}

export function addFeedGroupsData(feedGroups, data) {
  if(data.cowsNumber && data.calvingPeriod && data.dryPeriod) {

    const { cowsNumber, calvingPeriod, dryPeriod } = data
    const cattleNumberDryP = parseInt(cowsNumber) / parseInt(calvingPeriod) * dryPeriod
    const indexDryFeedGroup = feedGroups.findIndex(group => group.type === 1 && group.disabled === 1)

    feedGroups[indexDryFeedGroup] = {
      ...feedGroups[indexDryFeedGroup],
      days: dryPeriod,
      cattleNumber: cattleNumberDryP
    }

    const indexLactFeedGroup = feedGroups.findIndex(group => group.type === 2 && group.disabled === 1)

    const cattleNumberLactP = parseInt(cowsNumber) - cattleNumberDryP
    const daysLactatingPer = getDaysFromCowsNumber(parseInt(cowsNumber), calvingPeriod)

    feedGroups[indexLactFeedGroup] = {
      ...feedGroups[indexLactFeedGroup],
      days: daysLactatingPer,
      cattleNumber: cattleNumberLactP
    }

    return feedGroups

  } else {
    return feedGroups
  }
}